import logo from "./Assets/superscholars.png";
import logo1 from "./Assets/superscholars-logo.png";
import banner1 from "./Assets/1.png";
import banner2 from "./Assets/2.png";
import banner3 from "./Assets/3.png";
import banner6 from "./Assets/4.png";
import founder from "./Assets/founder.jpg";
import Course from "./Assets/courses/1.jpg";
import Course1 from "./Assets/courses/2.jpg";
import Course2 from "./Assets/courses/3.jpg";
import Course3 from "./Assets/courses/4.jpg";
import Course4 from "./Assets/courses/5.jpg";
import Course5 from "./Assets/courses/6.jpg";
import P1 from "./Assets/New folder/Picture1.jpg";
import P2 from "./Assets/New folder/Picture2.jpg";
import P3 from "./Assets/New folder/Picture3.jpg";
import P4 from "./Assets/New folder/Picture4.jpg";
import P5 from "./Assets/New folder/Picture5.jpg";
import P6 from "./Assets/New folder/Picture6.jpg";
import P7 from "./Assets/New folder/Picture7.jpg";
import P8 from "./Assets/New folder/Picture8.jpg";
import G1 from "./g1.jpeg";
import G2 from "./g2.jpeg";
import G3 from "./g3.jpeg";
import G4 from "./g4.jpeg";
import G5 from "./g5.jpeg";
import G6 from "./g6.jpeg";
import G7 from "./g7.jpeg";
import G8 from "./g8.jpeg";
import G9 from "./g9.jpeg";
import Banner4 from "./banner4.png";
import Banner5 from "./biglogo.jpg";
import module1 from "./Assets/module/1.jpeg";
import module2 from "./Assets/module/2.jpeg";
import module3 from "./Assets/module/3.jpeg";
import module4 from "./Assets/module/4.jpeg";
import module5 from "./Assets/module/5.jpeg";
import module6 from "./Assets/module/6.jpeg";
import module7 from "./Assets/module/7.jpeg";
import module8 from "./Assets/module/8.jpeg";
import module9 from "./Assets/module/9.jpeg";
import module10 from "./Assets/module/10.jpeg";

export default {
  logo,
  logo1,
  banner1,
  banner2,
  banner3,
  banner6,
  founder,
  Course,
  Course1,
  Course2,
  Course3,
  Course4,
  Course5,
  P1,
  P2,
  P3,
  P4,
  P5,
  P6,
  P7,
  P8,
  G1,
  G2,
  G3,
  G4,
  G5,
  G6,
  G7,
  G8,
  G9,
  Banner4,
  Banner5,
  module1,
  module2,
  module3,
  module4,
  module5,
  module6,
  module7,
  module8,
  module9,
  module10,
};
